import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { emptyString } from 'constants/defaultValues';
import LoadingWrapper from 'components/common/LoadingWrapper';

const PolicySummary = ({ policyData, loading }) => {
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid item container xs={12} md={6} lg={4} alignItems={'center'}>
        <strong>{`${t('Offer.Edit.PolicyData.InsurerName')}: `}</strong>{' '}
        <Grid item xs={6} md={4} ml={1}>
          <LoadingWrapper loading={loading}>
            <span id='PolicyData_Summary_InsurerName'>{policyData.insurerName || emptyString}</span>
          </LoadingWrapper>
        </Grid>
      </Grid>
      <Grid item container xs={12} md={6} lg={5} alignItems={'center'}>
        <strong>{`${t('Offer.Edit.PolicyData.InsuranceAmount')}: `}</strong>{' '}
        <Grid item xs={6} md={3} ml={1}>
          <LoadingWrapper loading={loading}>
            <span id='PolicyData_Summary_InsuranceAmount'>
              {policyData.insuranceAmount
                ? `${t('DECIMAL2', { number: policyData.insuranceAmount || emptyString })} ${policyData.currencyCode}`
                : emptyString}
            </span>
          </LoadingWrapper>
        </Grid>
      </Grid>
      <Grid item container xs={12} md={6} lg={3} alignItems={'center'}>
        <strong>{`${t('Offer.Edit.PolicyData.StartDate')}: `}</strong>{' '}
        <Grid item xs={6} md={5} ml={1}>
          <LoadingWrapper loading={loading}>
            <span id='PolicyData_Summary_StartDate'>{t('DATE', { date: policyData.startDate }) || emptyString}</span>
          </LoadingWrapper>
        </Grid>
      </Grid>
    </Grid>
  );
};

PolicySummary.propTypes = {
  policyData: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
};

export default PolicySummary;
